import { api } from './api-client';
import type {
  CreateAccountRequest, CreateAccountResponse, UpdateAccountRequest,
  ListAccountsResponse, AccountSummary, ResetPasswordResponse, ManageableClustersResponse,
} from '@livinhome/shared';

export type { AccountSummary };

export async function listManageableClusters(): Promise<ManageableClustersResponse['developers']> {
  const { data } = await api.get<ManageableClustersResponse>('/admin/accounts/clusters');
  return data.developers;
}
export async function listDeveloperManagers(): Promise<AccountSummary[]> {
  const { data } = await api.get<ListAccountsResponse>('/admin/accounts', { params: { type: 'developer_manager' } });
  return data.items;
}
export async function listClusterAdmins(clusterId: string): Promise<AccountSummary[]> {
  const { data } = await api.get<ListAccountsResponse>('/admin/accounts', { params: { type: 'cluster_admin', cluster_id: clusterId } });
  return data.items;
}
export async function listSecurity(clusterId: string): Promise<AccountSummary[]> {
  const { data } = await api.get<ListAccountsResponse>('/admin/accounts', { params: { type: 'security', cluster_id: clusterId } });
  return data.items;
}
export async function createAccount(body: CreateAccountRequest): Promise<CreateAccountResponse> {
  const { data } = await api.post<CreateAccountResponse>('/admin/accounts', body);
  return data;
}
export async function updateAccount(id: string, body: UpdateAccountRequest): Promise<void> {
  await api.patch(`/admin/accounts/${id}`, body);
}
export async function resetAccountPassword(id: string): Promise<ResetPasswordResponse> {
  const { data } = await api.post<ResetPasswordResponse>(`/admin/accounts/${id}/reset-password`);
  return data;
}
export async function deleteAccount(id: string): Promise<void> {
  await api.delete(`/admin/accounts/${id}`);
}
export async function addAdminToCluster(id: string, clusterId: string): Promise<void> {
  await api.post(`/admin/accounts/${id}/clusters`, { cluster_id: clusterId });
}
export async function removeAdminFromCluster(id: string, clusterId: string): Promise<void> {
  await api.delete(`/admin/accounts/${id}/clusters/${clusterId}`);
}
